var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('settings-page',{staticClass:"show-settings-add-ons",attrs:{"show":_vm.show}},[_c('hosting-add-on',{attrs:{"show":_vm.show}}),_vm._v(" "),_c('coming-soon-add-on')],1)}
var staticRenderFns = []

export { render, staticRenderFns }